import { type LogoProps } from '../registry';

export function SwingshiftLogo({
  width = 1024,
  height = 1024,
  className = 'h-auto max-w-full',
  ariaHidden = true,
}: LogoProps) {
  return (
    <svg
      id="swingshift-logo-layer"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      width={width}
      height={height}
      className={className}
      aria-hidden={ariaHidden}
    >
<path fill="#FFFFFF" opacity="1.000000" stroke="none" 
	d="
M449.000000,1025.000000 
	C299.333344,1025.000000 150.166672,1025.000000 1.000000,1025.000000 
	C1.000000,683.666687 1.000000,342.333344 1.000000,1.000000 
	C342.333344,1.000000 683.666687,1.000000 1025.000000,1.000000 
	C1025.000000,342.333344 1025.000000,683.666687 1025.000000,1025.000000 
	C833.166687,1025.000000 641.333313,1025.000000 449.000000,1025.000000 
M714.112427,646.471497 
	C781.745300,613.088806 849.353210,579.655396 917.042114,546.386902 
	C925.608093,542.176819 931.019226,536.184326 930.960449,526.390198 
	C930.902893,516.808655 925.551697,510.858490 917.173035,506.789642 
	C892.765381,494.936768 868.470398,482.851440 844.142029,470.835632 
	C737.421326,418.126007 630.679810,365.458466 524.031311,312.603210 
	C515.174438,308.213684 507.272308,308.213379 498.406250,312.621124 
	C367.953186,377.476501 237.421722,442.174194 106.864281,506.819305 
	C98.341797,511.039215 92.936211,516.986938 93.069534,526.872620 
	C93.199585,536.515869 98.590813,542.270691 106.940269,546.377197 
	C150.119354,567.614075 193.197128,589.057007 236.309692,610.429138 
	C324.314026,654.055481 412.332001,697.654358 500.297302,741.359253 
	C507.792877,745.083435 514.798157,745.015930 522.250122,741.325867 
	C585.960999,709.777222 649.723999,678.333801 714.112427,646.471497 
z"/>
<path fill="#1C3645" opacity="1.000000" stroke="none" 
	d="
M713.791931,646.665161 
	C649.723999,678.333801 585.960999,709.777222 522.250122,741.325867 
	C514.798157,745.015930 507.792877,745.083435 500.297302,741.359253 
	C412.332001,697.654358 324.314026,654.055481 236.309692,610.429138 
	C193.197128,589.057007 150.119354,567.614075 106.940269,546.377197 
	C98.590813,542.270691 93.199585,536.515869 93.069534,526.872620 
	C92.936211,516.986938 98.341797,511.039215 106.864281,506.819305 
	C237.421722,442.174194 367.953186,377.476501 498.406250,312.621124 
	C507.272308,308.213379 515.174438,308.213684 524.031311,312.603210 
	C630.679810,365.458466 737.421326,418.126007 844.142029,470.835632 
	C868.470398,482.851440 892.765381,494.936768 917.173035,506.789642 
	C925.551697,510.858490 930.902893,516.808655 930.960449,526.390198 
	C931.019226,536.184326 925.608093,542.176819 917.042114,546.386902 
	C849.353210,579.655396 781.745300,613.088806 713.791931,646.665161 
M476.914948,376.962189 
	C476.914948,376.962189 476.906372,376.881439 477.615875,376.910034 
	C481.853912,374.058350 486.091980,371.206696 490.945160,368.085266 
	C492.993317,366.560883 495.041473,365.036469 497.872467,363.296631 
	C498.506500,363.600433 499.605865,363.804169 499.696350,364.224854 
	C500.160187,366.381561 500.364288,368.594116 500.376190,371.369537 
	C500.663116,371.901581 500.950012,372.433594 501.353638,373.640594 
	C503.577423,376.932617 505.618225,380.368958 508.071014,383.480469 
	C511.195526,387.444122 513.780579,391.213806 510.773193,396.510315 
	C510.063171,397.760773 510.546021,399.762177 510.674774,401.402802 
	C511.302521,409.402557 512.305908,417.448212 505.006165,423.448273 
	C504.029205,424.251312 503.591675,425.684509 502.813171,426.759827 
	C500.188354,430.385376 498.985779,435.484741 493.262756,435.954590 
	C492.772095,435.994843 492.130127,436.763153 491.927856,437.325989 
	C490.647308,440.889008 489.154480,444.424561 488.399597,448.106140 
	C488.045685,449.832367 489.181030,451.863983 489.682709,453.926788 
	C494.848175,449.095825 499.612213,445.261749 503.607513,440.747314 
	C508.663391,435.034424 513.093689,428.767914 518.846313,422.880920 
	C519.192627,422.954193 519.538879,423.027435 519.529480,423.950775 
	C519.395935,427.967041 519.262451,431.983307 518.665894,436.360901 
	C518.733765,437.240601 518.801575,438.120331 518.840454,439.794403 
	C518.860229,443.389618 518.507385,446.725372 514.945618,448.913788 
	C513.896484,449.558411 513.449463,451.182953 512.726501,452.358459 
	C514.215942,452.843140 515.744751,453.832550 517.187500,453.719818 
	C521.919739,453.350220 525.309937,449.588623 526.157227,443.848236 
	C528.146240,430.372864 530.237427,416.904053 531.752258,403.372681 
	C532.170593,399.635956 531.224976,395.515198 530.001099,391.874573 
	C527.544373,384.566681 524.464661,377.468262 521.649780,370.303009 
	C528.650269,366.883209 528.860107,366.801758 525.987549,359.400482 
	C524.564453,355.733978 522.355774,352.331696 520.179199,349.022583 
	C519.509583,348.004608 517.187378,346.818848 516.617615,347.199677 
	C513.586670,349.225464 510.872101,351.724548 507.219604,354.225098 
	C506.393707,354.376617 505.567841,354.528137 504.377441,354.149628 
	C503.637970,353.389771 502.898499,352.629913 501.955109,351.268616 
	C500.502472,351.371979 499.049866,351.475342 496.980347,351.771210 
	C496.108704,352.683472 495.237061,353.595734 493.950775,354.804199 
	C494.136078,355.686737 494.321350,356.569305 494.810883,358.086426 
	C495.267273,359.395996 495.723694,360.705566 495.548706,362.291382 
	C493.352783,363.842072 491.156860,365.392761 488.273895,367.052765 
	C484.501068,369.794556 480.728271,372.536346 476.265564,375.695282 
	C475.043945,376.415710 473.009766,376.933746 472.769348,377.898651 
	C472.264069,379.927063 472.472748,382.240082 472.929230,384.317444 
	C473.028687,384.770081 475.396820,384.724274 476.720093,384.908020 
	C476.745209,383.322357 476.770325,381.736725 476.729584,379.338440 
	C476.773041,378.526459 476.816467,377.714447 476.914948,376.962189 
M479.984344,596.716187 
	C489.411316,599.490417 481.951904,590.367676 485.201782,589.346497 
	C487.121307,588.547058 488.697235,587.890686 490.655945,586.808472 
	C490.677307,586.247498 490.698669,585.686523 490.931519,584.459167 
	C490.220337,584.164001 489.509125,583.868896 487.992981,583.455444 
	C486.919189,583.347412 485.845428,583.239380 484.789917,582.281921 
	C484.662903,581.448792 484.535858,580.615662 485.004852,579.204529 
	C487.125336,579.014221 489.293549,579.026550 491.345154,578.543762 
	C492.299042,578.319275 493.026611,577.133118 493.856750,576.382935 
	C493.150238,575.681396 492.473633,574.412537 491.732147,574.373413 
	C487.867462,574.169434 483.986237,574.278259 480.008331,574.278259 
	C480.008331,582.119385 480.008331,589.057068 479.984344,596.716187 
M337.652161,515.376953 
	C339.150452,508.615265 340.648773,501.853577 342.146271,495.095581 
	C334.058502,493.432526 333.907959,493.509521 332.335083,500.348877 
	C331.439575,504.242828 330.635956,508.158081 329.723297,512.047852 
	C328.161743,518.703613 326.547028,525.346863 324.954651,531.995361 
	C321.188171,520.798584 318.440430,509.684631 316.127686,498.480896 
	C315.421600,495.060516 313.889374,494.363922 310.744598,494.230621 
	C307.435394,494.090424 306.369080,495.549805 305.819244,498.384613 
	C304.995239,502.632721 304.001312,506.850891 302.972015,511.055450 
	C301.320892,517.800293 299.581726,524.523621 297.879730,531.256042 
	C297.434784,531.218384 296.989838,531.180725 296.544861,531.143005 
	C296.312317,530.435120 296.019165,529.740845 295.856384,529.017212 
	C293.684174,519.361572 291.552399,509.696716 289.363922,500.044769 
	C287.913269,493.646912 286.822296,493.105988 280.031219,495.310608 
	C280.031219,495.755981 279.939240,496.265137 280.044525,496.729553 
	C283.909363,513.780151 287.867218,530.810181 291.618378,547.885620 
	C292.509399,551.941772 295.401978,550.800964 297.864288,550.910400 
	C300.336365,551.020325 302.634705,551.344604 303.363464,547.636108 
	C305.128082,538.656128 307.385071,529.772095 309.499725,520.862671 
	C309.800964,519.593445 310.414154,518.398193 311.337585,515.976379 
	C313.918182,527.337646 316.319366,537.208435 318.336029,547.157166 
	C319.068237,550.769348 321.121826,551.163330 324.058716,550.956787 
	C326.756348,550.767029 329.480865,551.685120 330.333923,547.344727 
	C332.387268,536.897339 335.064362,526.572571 337.652161,515.376953 
M427.892242,513.499939 
	C427.892242,519.726013 427.892242,525.952026 427.892242,532.178101 
	C426.084595,531.290710 425.385437,530.267700 424.859222,529.162354 
	C420.497528,520.000183 416.130524,510.840240 411.839630,501.644836 
	C408.035675,493.492920 407.265594,493.077271 398.204834,495.010345 
	C398.204834,513.553589 398.204834,532.096802 398.204834,550.597961 
	C406.295410,551.302551 406.294647,551.302551 406.294312,543.664368 
	C406.293945,535.171570 406.280640,526.678650 406.307983,518.185974 
	C406.313477,516.484253 406.476349,514.783081 406.566650,513.081726 
	C408.195801,514.009033 408.800079,515.096130 409.331482,516.217712 
	C413.747894,525.538269 418.168732,534.856812 422.552094,544.192932 
	C426.046173,551.634949 427.835693,552.443604 435.932037,550.091919 
	C435.932037,531.675415 435.932037,513.264893 435.932037,494.906616 
	C427.929230,493.695099 427.898682,493.718445 427.892975,501.010223 
	C427.889954,504.840302 427.892273,508.670410 427.892242,513.499939 
M575.621887,494.376953 
	C571.626953,494.360779 567.562683,494.808777 563.652588,494.224762 
	C557.002991,493.231598 552.605469,496.271210 548.713745,501.025269 
	C546.264587,504.017120 545.851135,516.992493 548.339600,519.955322 
	C552.299561,524.670166 556.570129,528.558472 563.557007,527.114868 
	C565.951843,526.620056 568.711548,526.476074 570.981018,527.194214 
	C573.173279,527.888000 576.286316,529.636841 576.628723,531.385559 
	C577.339844,535.018005 578.606384,540.413879 573.668762,541.757446 
	C569.039795,543.017090 563.618835,542.905273 558.943420,541.766663 
	C556.799500,541.244507 555.606689,536.816589 553.292786,533.031433 
	C551.776550,533.635803 547.854553,534.034363 547.185303,535.722473 
	C546.005249,538.699036 546.468079,542.204285 549.350037,545.279846 
	C553.295898,549.490845 557.380859,551.775757 563.265198,551.034729 
	C566.870483,550.580811 570.581665,551.024536 574.239990,550.904358 
	C575.512146,550.862610 576.972839,550.652344 578.000000,549.984680 
	C587.336975,543.915405 588.667358,530.149658 581.069092,522.205872 
	C578.288086,519.298462 575.437500,517.941284 571.450989,518.314270 
	C568.315552,518.607666 565.123047,518.235046 561.970093,518.411621 
	C558.647034,518.597656 556.076050,517.218689 555.634888,514.118774 
	C555.092896,510.311127 554.018433,505.021881 558.754028,503.656158 
	C563.349854,502.330750 568.786316,502.470703 573.474854,503.575073 
	C575.576172,504.070099 576.753357,508.488251 578.825439,511.911804 
	C580.263855,511.839081 582.807434,511.710480 585.082397,511.595490 
	C587.827698,502.544830 581.827820,498.687958 575.621887,494.376953 
M461.639313,506.147522 
	C461.638550,516.970337 461.567627,527.794128 461.704529,538.615173 
	C461.727966,540.469055 462.154938,542.678284 463.227539,544.092285 
	C466.748932,548.734741 470.918488,552.163269 477.543976,551.042969 
	C481.105652,550.440857 484.852966,550.979126 488.515076,550.917358 
	C492.215637,550.854980 499.803101,544.852966 499.980682,541.275330 
	C500.307343,534.693848 500.073822,528.084534 500.073822,521.006714 
	C496.489380,521.006714 493.531647,521.006226 490.573914,521.006836 
	C483.165558,521.008362 482.900909,521.360474 484.555054,529.330811 
	C486.710968,529.566040 488.951904,529.810608 491.523743,530.091187 
	C491.523743,532.661255 491.733978,534.985840 491.476532,537.257385 
	C491.045013,541.064941 488.528229,542.978516 484.899200,542.366882 
	C479.861664,541.517883 473.116699,545.746704 470.295563,537.799072 
	C470.241608,537.647034 470.246796,537.469177 470.246735,537.303406 
	C470.242615,527.646301 470.132355,517.987366 470.296234,508.333038 
	C470.355774,504.826263 472.609161,502.481995 476.131500,503.045837 
	C481.369629,503.884430 488.539703,499.477020 491.346619,507.435211 
	C493.448090,513.393311 493.456726,513.817322 499.750183,512.027466 
	C501.093231,506.184845 500.139893,501.016754 494.781799,497.656128 
	C492.416412,496.172546 489.665344,494.834442 486.953033,494.483215 
	C482.859070,493.953094 478.645630,494.328461 474.483124,494.349365 
	C469.033630,494.376770 462.816742,499.692657 461.639313,506.147522 
M227.629959,550.518921 
	C232.268875,550.664185 236.967407,550.395874 241.532410,551.053833 
	C247.994843,551.985229 252.253403,549.011841 256.030151,544.427856 
	C258.461639,541.476685 258.932587,528.350159 256.444244,525.453735 
	C252.595184,520.973328 248.554138,516.894165 241.716171,518.303528 
	C239.640106,518.731445 237.401123,518.387268 235.237045,518.366333 
	C229.190826,518.307983 227.775772,516.801819 227.807648,510.495453 
	C227.836609,504.764526 229.537079,503.014771 235.151642,502.954010 
	C236.483337,502.939575 237.815338,502.953247 239.147202,502.953003 
	C248.108749,502.951355 248.108749,502.951263 249.873962,511.522400 
	C252.408920,511.522400 254.954025,511.522400 258.477936,511.522400 
	C257.776855,507.855377 258.024628,504.172485 256.406189,501.722443 
	C253.036606,496.621368 248.424667,493.019287 241.410217,494.224091 
	C238.014130,494.807465 234.430603,494.222839 230.941284,494.377625 
	C229.521103,494.440643 227.880661,494.708862 226.757553,495.486267 
	C217.194061,502.106384 216.206177,515.232910 224.300873,523.616577 
	C226.690964,526.091919 229.092880,527.355896 232.567474,527.098450 
	C236.210068,526.828613 239.997589,526.510864 243.509781,527.238037 
	C245.610779,527.672913 248.580185,529.835999 248.914062,531.638184 
	C249.587662,535.274048 250.836823,540.659912 245.713913,541.861816 
	C241.040253,542.958374 235.687607,542.685242 231.007980,541.517700 
	C229.001907,541.017151 227.942078,536.724060 226.221313,533.755615 
	C219.440598,532.991394 217.090729,535.073792 219.593231,541.558899 
	C220.868454,544.863586 224.413422,547.292358 227.629959,550.518921 
M649.279480,546.974487 
	C649.280701,531.646790 649.284241,516.319092 649.282166,500.991364 
	C649.281189,493.688721 648.485535,493.119507 640.716248,495.300537 
	C640.716248,502.760864 640.716248,510.361786 640.716248,518.026367 
	C633.342285,518.026367 626.448975,518.026367 619.057983,518.026367 
	C619.057983,510.087494 619.057983,502.502014 619.057983,495.027710 
	C610.795715,493.498962 610.603333,493.648163 610.601379,501.256561 
	C610.597595,515.584595 610.598877,529.912659 610.600220,544.240723 
	C610.600891,551.601074 611.177429,552.023926 619.238647,550.064880 
	C619.238647,542.632263 619.238647,535.051025 619.238647,527.367065 
	C626.673462,527.367065 633.558960,527.367065 640.978577,527.367065 
	C640.978577,535.275574 640.978577,542.850281 640.978577,551.029724 
	C644.182556,549.796814 648.315613,553.657471 649.279480,546.974487 
M735.428894,502.966217 
	C736.761353,502.965546 738.110596,502.829071 739.423096,502.990631 
	C742.855652,503.413208 744.041626,502.121887 744.071716,498.563446 
	C744.103943,494.765991 742.438538,494.197266 739.227600,494.253906 
	C730.402771,494.409668 721.568420,494.477386 712.747925,494.226288 
	C708.958313,494.118439 707.914185,495.386108 707.958679,499.081451 
	C708.141052,514.236145 708.033142,529.394348 708.036316,544.551208 
	C708.037842,551.724365 708.956177,552.338196 716.855225,549.912842 
	C716.855225,542.535645 716.855225,534.972717 716.855225,526.868347 
	C724.156433,526.868347 730.898438,526.868347 737.742310,526.868347 
	C737.742310,523.875671 737.742310,521.447571 737.742310,518.253784 
	C730.618103,518.253784 723.754456,518.253784 717.113281,518.253784 
	C717.113281,512.745911 717.113281,508.018066 717.113281,502.966217 
	C723.166321,502.966217 728.806396,502.966217 735.428894,502.966217 
M782.500549,546.124878 
	C782.606323,547.573486 782.712097,549.022034 782.827271,550.599243 
	C785.649231,550.599243 788.057007,550.599243 791.206116,550.599243 
	C791.206116,534.588257 791.206116,518.895203 791.206116,502.770874 
	C796.052979,502.770874 800.159058,502.770874 804.519165,502.770874 
	C804.519165,499.896118 804.519165,497.478241 804.519165,494.733826 
	C792.664185,494.733826 780.975830,494.733826 769.238098,494.733826 
	C769.238098,497.556976 769.238098,499.988586 769.238098,503.095215 
	C773.710815,503.095215 777.923584,503.095215 782.499695,503.095215 
	C782.499695,517.580933 782.499695,531.391052 782.500549,546.124878 
M363.877075,501.766235 
	C363.877045,515.908997 363.876068,530.051697 363.877411,544.194458 
	C363.878113,551.712280 364.762695,552.335144 372.510162,550.050415 
	C372.590668,548.832764 372.750397,547.529907 372.751770,546.226990 
	C372.768524,530.586792 372.600037,514.943848 372.864014,499.308167 
	C372.939117,494.860260 371.232941,494.030396 367.333862,494.227051 
	C362.010895,494.495544 364.495819,498.382507 363.877075,501.766235 
M683.009033,533.498413 
	C683.009033,520.614990 683.009033,507.731506 683.009033,494.159851 
	C679.395874,495.425293 674.379272,491.223694 674.319458,498.075531 
	C674.175964,514.514709 674.354736,530.956665 674.209106,547.395813 
	C674.177979,550.908142 676.022400,551.033203 678.597778,551.010315 
	C681.111633,550.987976 683.236816,551.014709 683.056641,547.447998 
	C682.838989,543.141357 683.007568,538.815247 683.009033,533.498413 
M614.901611,575.388367 
	C614.836487,581.549377 614.670898,587.712463 614.795776,593.869629 
	C614.819214,595.022888 615.989075,597.120544 616.657532,597.131714 
	C620.270996,597.192383 624.342041,597.698792 627.424683,596.265259 
	C635.365906,592.572205 628.444702,585.585815 629.833130,580.198181 
	C630.187256,578.823914 626.259705,575.469482 623.730591,574.483093 
	C621.348511,573.554077 618.216553,574.547974 614.901611,575.388367 
M397.467041,588.501587 
	C397.465302,587.173462 397.451782,585.845215 397.463837,584.517212 
	C397.521210,578.199280 399.052734,577.421936 404.760986,580.536316 
	C405.847412,581.129089 407.355316,580.949402 408.919739,581.159851 
	C407.577179,575.097351 405.439819,573.639587 399.578522,574.107605 
	C395.213196,574.456116 392.987518,576.964722 392.725250,581.174011 
	C392.539795,584.150696 392.568604,587.154114 392.715912,590.135071 
	C392.948883,594.848450 395.613190,597.367676 400.306824,597.562317 
	C407.352417,597.854431 410.180511,593.795288 408.556061,584.719055 
	C406.116455,585.086182 403.632629,585.460022 401.148834,585.833801 
	C402.019958,587.611450 402.891113,589.389160 404.081390,591.818054 
	C401.508087,592.265198 398.576202,594.923523 397.467041,588.501587 
M422.356323,578.407227 
	C422.233215,582.707520 421.584808,587.085510 422.205170,591.275757 
	C422.522583,593.419556 424.772980,596.408691 426.735504,596.970947 
	C433.325867,598.858948 440.787323,597.608337 439.967682,587.899841 
	C439.856354,586.581665 439.896149,585.243225 439.962280,583.919006 
	C440.163452,579.888367 439.807587,575.679077 435.260010,574.618164 
	C430.893433,573.599426 425.899475,572.575073 422.356323,578.407227 
M584.823486,574.578064 
	C584.643738,580.472717 583.871521,586.428711 584.473938,592.242310 
	C584.945068,596.788940 589.075745,597.765259 593.282898,597.595703 
	C597.363770,597.431274 600.038757,595.593201 600.330200,591.425476 
	C600.653931,586.795837 600.722473,582.129578 600.523376,577.495605 
	C600.474792,576.364807 598.946777,575.297607 598.098999,574.201172 
	C597.351562,575.389709 596.058777,576.534546 595.959473,577.774963 
	C595.668762,581.407166 595.786316,585.078979 595.874146,588.732178 
	C595.939392,591.446045 594.705994,593.179993 592.089294,592.480469 
	C590.745117,592.121155 589.059692,590.188538 588.897278,588.806091 
	C588.454346,585.036255 588.975281,581.156982 588.592590,577.373901 
	C588.477844,576.239624 586.647217,575.278931 584.823486,574.578064 
M531.958679,581.002380 
	C533.424255,577.739380 535.720154,578.656067 538.176270,579.642517 
	C539.734375,580.268311 541.433594,580.542786 543.771851,581.160278 
	C541.370483,574.791687 538.841736,573.291809 533.335754,574.174194 
	C528.714417,574.914917 527.018555,578.004944 527.081177,582.383179 
	C527.124084,585.380310 526.829163,588.423950 527.255127,591.364258 
	C527.918396,595.941895 531.163818,597.660400 535.519470,597.570251 
	C539.765625,597.482300 542.787903,595.901672 543.427734,590.316223 
	C541.404968,590.863831 539.849854,591.056458 538.502808,591.690735 
	C533.758545,593.924744 531.862854,592.765320 531.808533,587.405151 
	C531.790039,585.573120 531.828125,583.740601 531.958679,581.002380 
M904.523132,533.602844 
	C906.547546,534.648926 908.571960,535.694946 911.971497,537.451538 
	C908.457336,531.394104 910.482483,527.454773 915.206116,523.841431 
	C908.532349,525.316772 906.109436,521.446960 904.017151,516.256287 
	C903.606201,523.412109 898.901855,524.025330 893.307007,524.270264 
	C899.249634,527.245056 899.789673,531.517212 896.931763,537.552063 
	C900.079712,535.791565 901.920654,534.761963 904.523132,533.602844 
M116.067757,523.050903 
	C113.842346,523.371094 111.616936,523.691284 107.683861,524.257141 
	C114.017914,527.409668 115.255989,531.479980 112.183617,536.970825 
	C119.780373,533.860718 119.780373,533.860718 126.204094,536.760437 
	C125.846077,534.207458 124.768806,531.601929 125.393913,529.503601 
	C125.976776,527.546997 128.369659,526.129578 130.260910,524.168945 
	C123.454544,523.062866 123.454544,523.062866 119.287903,516.413574 
	C118.363983,518.589417 117.533737,520.544617 116.067757,523.050903 
M561.654053,587.464966 
	C561.652954,583.984375 561.835754,580.487854 561.537109,577.032959 
	C561.449280,576.015930 559.998474,575.116577 559.172302,574.163330 
	C558.340454,575.130249 556.882141,576.041931 556.791199,577.074097 
	C556.487061,580.528137 556.669922,584.025208 556.669556,587.505798 
	C556.668579,597.658936 556.673523,597.758911 566.588013,597.328308 
	C568.032410,597.265564 569.412354,595.718506 570.822144,594.858276 
	C569.372803,594.028198 567.971436,592.618103 566.463806,592.493591 
	C563.662415,592.262146 560.948486,592.596924 561.654053,587.464966 
M453.177765,586.474243 
	C453.177673,597.975769 453.177887,597.979919 464.636780,597.420044 
	C465.282196,597.388550 465.919983,597.199402 466.714661,597.055969 
	C466.714661,595.573608 466.714661,594.186829 466.714661,592.593079 
	C463.677338,592.412659 460.957031,592.251038 457.988068,592.074646 
	C457.988068,586.766052 458.119446,581.965637 457.884369,577.183228 
	C457.833435,576.147339 456.466003,575.176208 455.705017,574.175232 
	C454.864594,575.127625 453.426636,576.006714 453.299164,577.046448 
	C452.958344,579.826782 453.179871,582.676147 453.177765,586.474243 
M544.162964,652.538208 
	C541.337402,651.705688 538.537598,650.600403 535.659180,650.328674 
	C535.216614,650.286865 534.298462,654.056030 533.820190,656.113892 
	C533.563477,657.218323 533.738037,658.432922 533.782471,659.595337 
	C533.873108,661.964172 532.993713,664.863831 537.105896,664.820496 
	C540.838806,664.781128 544.352112,664.556946 544.722778,659.756165 
	C544.887390,657.624878 544.576538,655.456848 544.162964,652.538208 
M513.829895,703.222168 
	C518.331726,700.199402 518.418091,698.528503 513.758057,694.163086 
	C515.113464,693.576294 516.440308,693.001831 517.585938,692.505859 
	C514.656982,687.897461 511.565887,687.284607 508.482513,689.607666 
	C504.916199,692.294556 507.140472,695.034790 509.431671,697.370850 
	C506.345001,699.630554 506.119019,701.395447 508.804626,702.743958 
	C510.039215,703.363892 511.655731,703.223267 513.829895,703.222168 
M522.963196,664.632568 
	C524.260193,663.309265 526.841919,661.066711 526.654907,660.805420 
	C524.855103,658.290161 522.588928,656.108643 519.936096,653.276184 
	C522.162231,653.853394 523.981445,654.325134 525.800659,654.796814 
	C526.121460,654.440308 526.442261,654.083801 526.763062,653.727295 
	C525.610657,652.501953 524.591553,650.461487 523.273987,650.246094 
	C521.394653,649.938782 518.920837,650.475525 517.430420,651.610046 
	C516.511658,652.309387 516.827209,654.792358 516.830383,656.473999 
	C516.832092,657.343628 517.874023,658.499878 517.572876,659.037292 
	C514.248169,664.970459 518.946228,664.282776 522.963196,664.632568 
M495.027710,699.181152 
	C491.666870,701.296509 491.528290,698.918823 491.400757,696.566772 
	C491.254517,693.870117 491.135437,691.171936 491.004517,688.474365 
	C490.303894,688.506165 489.603271,688.537903 488.902679,688.569702 
	C487.585907,692.844238 487.187317,697.358276 489.171173,701.526917 
	C490.736969,704.817139 497.383850,704.365662 498.102783,700.911438 
	C498.921631,696.977417 498.292114,692.741943 498.292114,688.637451 
	C494.035858,691.246765 495.951996,695.071960 495.027710,699.181152 
M474.054199,663.620178 
	C474.511169,660.287781 475.464417,656.913330 475.186981,653.643250 
	C475.072021,652.288330 472.405884,650.304443 470.751434,650.144592 
	C468.791809,649.955322 465.165497,651.087402 464.905670,652.241760 
	C464.146545,655.615051 463.824677,659.666626 465.131775,662.668457 
	C465.741058,664.067810 470.505951,663.657593 474.054199,663.620178 
M591.323059,655.847412 
	C590.489136,655.460388 589.655273,655.073425 588.195557,654.395996 
	C591.143616,653.300903 593.164062,652.550415 595.184570,651.799927 
	C595.022949,651.317566 594.861328,650.835266 594.699707,650.352905 
	C591.845093,650.352905 588.990479,650.352905 586.081238,650.352905 
	C586.081238,655.223938 586.081238,659.769653 586.081238,664.721008 
	C589.334961,664.557800 592.157288,664.416260 594.979614,664.274719 
	C595.060730,663.736633 595.141907,663.198486 595.223022,662.660400 
	C593.048950,661.930725 590.874878,661.201050 587.730164,660.145569 
	C593.109558,658.410400 593.109558,658.410400 591.323059,655.847412 
M528.459534,689.454041 
	C526.685730,693.907898 524.911865,698.361755 523.005432,703.148376 
	C524.059692,703.130981 535.387817,702.943970 536.296387,702.928955 
	C534.459900,698.325500 532.772339,693.969360 530.932251,689.678772 
	C530.749573,689.252686 529.636292,689.225647 528.459534,689.454041 
M448.576904,664.033386 
	C454.242126,665.589539 455.663971,664.955505 456.272797,660.480530 
	C454.284668,659.397217 450.391937,664.418701 449.760834,658.246277 
	C449.092072,651.705627 453.467957,654.032043 456.963074,653.405212 
	C455.416718,651.748962 453.570068,649.960083 451.955658,650.149597 
	C450.068451,650.371094 447.049164,652.155518 446.879456,653.549072 
	C446.484100,656.795715 447.502686,660.214539 448.576904,664.033386 
M551.096375,662.364136 
	C551.268127,665.296570 552.418884,664.830505 553.943848,663.198669 
	C556.051636,660.943176 558.043945,660.971863 560.086975,663.382751 
	C560.586853,663.972656 561.577332,664.146973 562.342285,664.512329 
	C562.669617,664.272827 562.997009,664.033386 563.324341,663.793884 
	C561.462341,659.171143 559.600342,654.548340 557.738342,649.925598 
	C557.186035,649.954651 556.633728,649.983643 556.081482,650.012634 
	C554.486206,653.888977 552.890991,657.765320 551.096375,662.364136 
M434.715424,656.791382 
	C433.958862,655.886353 433.202301,654.981323 432.445709,654.076294 
	C432.657928,653.738892 432.870117,653.401489 433.082336,653.064087 
	C434.885376,653.594116 436.688385,654.124146 438.491425,654.654114 
	C438.801941,654.162903 439.112457,653.671692 439.422943,653.180481 
	C437.864685,652.118591 436.246277,650.131348 434.763336,650.227722 
	C432.884003,650.349915 429.975311,651.809021 429.504303,653.315063 
	C427.865784,658.554321 433.499359,657.979797 436.054413,659.913269 
	C435.936218,660.402222 435.817993,660.891174 435.699799,661.380127 
	C433.539581,661.028076 431.379333,660.676025 429.219116,660.324036 
	C428.951630,660.683167 428.684113,661.042358 428.416595,661.401550 
	C429.802490,662.317261 431.304138,664.119690 432.549255,663.957214 
	C434.873810,663.653748 437.049347,662.208801 439.286896,661.238892 
	C438.013092,659.797058 436.739288,658.355164 434.715424,656.791382 
M502.820465,649.979248 
	C501.589020,650.266296 500.357574,650.553406 500.401215,650.543213 
	C501.677307,655.884094 502.731689,660.297058 504.120544,666.110107 
	C505.757782,659.960815 507.004852,655.276855 508.415619,649.978088 
	C507.199280,649.978088 505.443756,649.978088 502.820465,649.979248 
M488.648041,661.016724 
	C489.365082,657.549744 490.082123,654.082764 490.798523,650.619019 
	C488.369324,650.619019 485.185150,650.619019 483.244263,650.619019 
	C483.932892,654.617065 484.482880,658.180725 485.195709,661.711426 
	C485.396393,662.705261 486.074829,663.602600 486.534149,664.544250 
	C487.236481,663.644775 487.938812,662.745300 488.648041,661.016724 
M569.596863,654.018005 
	C569.609497,656.819580 568.937012,659.894287 569.902466,662.315979 
	C570.445374,663.677979 573.648010,664.163269 575.744507,664.625610 
	C576.507874,664.793884 577.538452,663.750732 578.447144,663.260315 
	C577.010437,662.581177 575.569885,661.909912 574.140198,661.216187 
	C573.857849,661.079224 573.617310,660.856140 573.226379,660.580200 
	C573.036011,657.192078 572.840393,653.710510 572.644836,650.228943 
	C572.146118,650.120422 571.647400,650.011902 571.148682,649.903381 
	C570.633972,650.990356 570.119324,652.077271 569.596863,654.018005 
M461.816101,408.804871 
	C463.076721,408.567078 465.196655,408.662994 465.442108,408.030975 
	C466.287842,405.853271 466.925171,403.381378 466.721497,401.103882 
	C466.626831,400.045837 464.437073,398.466888 463.153076,398.423462 
	C461.877777,398.380249 459.438812,399.981476 459.449188,400.838074 
	C459.480042,403.385101 460.464752,405.920593 461.816101,408.804871 
M450.833984,409.292786 
	C452.354095,409.085693 453.874207,408.878601 456.340759,408.542542 
	C454.741669,407.018372 453.962463,406.275696 453.183289,405.532990 
	C453.585449,405.525482 453.987610,405.517975 454.389771,405.510468 
	C454.389771,403.317200 454.389771,401.123962 454.389771,398.930695 
	C452.545410,399.203094 450.701019,399.475494 448.856659,399.747894 
	C448.946106,400.229675 449.035583,400.711456 449.125031,401.193237 
	C450.028809,401.571136 450.932587,401.949005 451.456024,402.167877 
	C451.281342,404.873596 445.077515,405.709869 450.833984,409.292786 
M559.614685,405.382477 
	C560.056274,406.608948 560.304932,408.740875 560.977356,408.884155 
	C562.678162,409.246521 564.569458,408.715240 567.407593,408.444244 
	C565.636353,406.901611 564.835938,406.204468 564.035461,405.507294 
	C564.495422,405.442139 564.955383,405.376984 565.415344,405.311829 
	C565.415344,403.232910 565.415344,401.154022 565.415344,399.075134 
	C563.472595,399.210297 561.529846,399.345459 559.587158,399.480591 
	C559.600159,399.963806 559.613220,400.447021 559.626221,400.930237 
	C560.515076,401.537201 561.403931,402.144135 562.434143,402.847595 
	C561.389221,403.712799 560.752930,404.239746 559.614685,405.382477 
M569.713196,407.104279 
	C571.361023,407.569794 573.008911,408.035339 575.732117,408.804688 
	C575.446838,404.999451 575.211975,401.865967 574.977051,398.732513 
	C574.266724,398.575378 573.556396,398.418243 572.846069,398.261139 
	C571.582703,401.129944 570.319336,403.998718 569.713196,407.104279 
z"/>
<path fill="#F4F5F5" opacity="1.000000" stroke="none" 
	d="
M502.159058,351.870056 
	C502.898499,352.629913 503.637970,353.389771 504.654907,354.743469 
	C505.504425,356.045532 506.076477,356.753693 506.594788,357.794189 
	C506.581757,362.984436 510.100555,361.660187 512.581421,361.157013 
	C514.172485,360.834290 516.788147,359.200134 516.738525,358.271698 
	C516.541504,354.584869 513.266479,355.759918 510.970886,355.546783 
	C510.328918,355.487183 509.662659,355.688751 508.917145,355.540955 
	C508.567169,354.894165 508.307587,354.476990 508.048035,354.059814 
	C510.872101,351.724548 513.586670,349.225464 516.617615,347.199677 
	C517.187378,346.818848 519.509583,348.004608 520.179199,349.022583 
	C522.355774,352.331696 524.564453,355.733978 525.987549,359.400482 
	C528.860107,366.801758 528.650269,366.883209 521.649780,370.303009 
	C524.464661,377.468262 527.544373,384.566681 530.001099,391.874573 
	C531.224976,395.515198 532.170593,399.635956 531.752258,403.372681 
	C530.237427,416.904053 528.146240,430.372864 526.157227,443.848236 
	C525.309937,449.588623 521.919739,453.350220 517.187500,453.719818 
	C515.744751,453.832550 514.215942,452.843140 512.726501,452.358459 
	C513.449463,451.182953 513.896484,449.558411 514.945618,448.913788 
	C518.507385,446.725372 518.860229,443.389618 519.090393,439.228912 
	C519.269897,437.775482 519.199463,436.887512 519.128967,435.999573 
	C519.262451,431.983307 519.395935,427.967041 520.002014,423.395142 
	C521.470520,419.604370 522.466553,416.369232 523.462585,413.134064 
	C522.962097,412.949402 522.461609,412.764709 521.961121,412.580048 
	C520.572021,415.966736 519.182922,419.353455 517.793823,422.740143 
	C513.093689,428.767914 508.663391,435.034424 503.607513,440.747314 
	C499.612213,445.261749 494.848175,449.095825 489.682709,453.926788 
	C489.181030,451.863983 488.045685,449.832367 488.399597,448.106140 
	C489.154480,444.424561 490.647308,440.889008 491.927856,437.325989 
	C492.130127,436.763153 492.772095,435.994843 493.262756,435.954590 
	C498.985779,435.484741 500.188354,430.385376 502.813171,426.759827 
	C503.591675,425.684509 504.029205,424.251312 505.006165,423.448273 
	C512.305908,417.448212 511.302521,409.402557 510.674774,401.402802 
	C510.546021,399.762177 510.063171,397.760773 510.773193,396.510315 
	C513.780579,391.213806 511.195526,387.444122 508.071014,383.480469 
	C505.618225,380.368958 503.577423,376.932617 501.490784,373.159607 
	C501.304993,372.048096 500.982086,371.417633 500.659149,370.787170 
	C500.364288,368.594116 500.160187,366.381561 499.696350,364.224854 
	C499.605865,363.804169 498.506500,363.600433 497.443695,363.096375 
	C496.736633,362.602478 496.458344,362.308807 496.180084,362.015137 
	C495.723694,360.705566 495.267273,359.395996 494.750183,357.276672 
	C494.581451,355.813934 494.473450,355.160950 494.365417,354.507996 
	C495.237061,353.595734 496.108704,352.683472 497.734467,351.789551 
	C499.712067,351.828613 500.935577,351.849335 502.159058,351.870056 
z"/>
<path fill="#F0F1F2" opacity="1.000000" stroke="none" 
	d="
M337.571014,515.787598 
	C335.064362,526.572571 332.387268,536.897339 330.333923,547.344727 
	C329.480865,551.685120 326.756348,550.767029 324.058716,550.956787 
	C321.121826,551.163330 319.068237,550.769348 318.336029,547.157166 
	C316.319366,537.208435 313.918182,527.337646 311.337585,515.976379 
	C310.414154,518.398193 309.800964,519.593445 309.499725,520.862671 
	C307.385071,529.772095 305.128082,538.656128 303.363464,547.636108 
	C302.634705,551.344604 300.336365,551.020325 297.864288,550.910400 
	C295.401978,550.800964 292.509399,551.941772 291.618378,547.885620 
	C287.867218,530.810181 283.909363,513.780151 280.044525,496.729553 
	C279.939240,496.265137 280.031219,495.755981 280.031219,495.310608 
	C286.822296,493.105988 287.913269,493.646912 289.363922,500.044769 
	C291.552399,509.696716 293.684174,519.361572 295.856384,529.017212 
	C296.019165,529.740845 296.312317,530.435120 296.544861,531.143005 
	C296.989838,531.180725 297.434784,531.218384 297.879730,531.256042 
	C299.581726,524.523621 301.320892,517.800293 302.972015,511.055450 
	C304.001312,506.850891 304.995239,502.632721 305.819244,498.384613 
	C306.369080,495.549805 307.435394,494.090424 310.744598,494.230621 
	C313.889374,494.363922 315.421600,495.060516 316.127686,498.480896 
	C318.440430,509.684631 321.188171,520.798584 324.954651,531.995361 
	C326.547028,525.346863 328.161743,518.703613 329.723297,512.047852 
	C330.635956,508.158081 331.439575,504.242828 332.335083,500.348877 
	C333.907959,493.509521 334.058502,493.432526 342.146271,495.095581 
	C340.648773,501.853577 339.150452,508.615265 337.571014,515.787598 
z"/>
<path fill="#F4F5F5" opacity="1.000000" stroke="none" 
	d="
M427.892212,513.000244 
	C427.892273,508.670410 427.889954,504.840302 427.892975,501.010223 
	C427.898682,493.718445 427.929230,493.695099 435.932037,494.906616 
	C435.932037,513.264893 435.932037,531.675415 435.932037,550.091919 
	C427.835693,552.443604 426.046173,551.634949 422.552094,544.192932 
	C418.168732,534.856812 413.747894,525.538269 409.331482,516.217712 
	C408.800079,515.096130 408.195801,514.009033 406.566650,513.081726 
	C406.476349,514.783081 406.313477,516.484253 406.307983,518.185974 
	C406.280640,526.678650 406.293945,535.171570 406.294312,543.664368 
	C406.294647,551.302551 406.295410,551.302551 398.204834,550.597961 
	C398.204834,532.096802 398.204834,513.553589 398.204987,495.008850 
	C407.265594,493.077271 408.035675,493.492920 411.839630,501.644836 
	C416.130524,510.840240 420.497528,520.000183 424.859222,529.162354 
	C425.385437,530.267700 426.084595,531.290710 427.892242,532.178101 
	C427.892242,525.952026 427.892242,519.726013 427.892212,513.000244 
z"/>
<path fill="#EDEFF0" opacity="1.000000" stroke="none" 
	d="
M576.027893,494.440735 
	C581.827820,498.687958 587.827698,502.544830 585.082397,511.595490 
	C582.807434,511.710480 580.263855,511.839081 578.825439,511.911804 
	C576.753357,508.488251 575.576172,504.070099 573.474854,503.575073 
	C568.786316,502.470703 563.349854,502.330750 558.754028,503.656158 
	C554.018433,505.021881 555.092896,510.311127 555.634888,514.118774 
	C556.076050,517.218689 558.647034,518.597656 561.970093,518.411621 
	C565.123047,518.235046 568.315552,518.607666 571.450989,518.314270 
	C575.437500,517.941284 578.288086,519.298462 581.069092,522.205872 
	C588.667358,530.149658 587.336975,543.915405 578.000000,549.984680 
	C576.972839,550.652344 575.512146,550.862610 574.239990,550.904358 
	C570.581665,551.024536 566.870483,550.580811 563.265198,551.034729 
	C557.380859,551.775757 553.295898,549.490845 549.350037,545.279846 
	C546.468079,542.204285 546.005249,538.699036 547.185303,535.722473 
	C547.854553,534.034363 551.776550,533.635803 553.292786,533.031433 
	C555.606689,536.816589 556.799500,541.244507 558.943420,541.766663 
	C563.618835,542.905273 569.039795,543.017090 573.668762,541.757446 
	C578.606384,540.413879 577.339844,535.018005 576.628723,531.385559 
	C576.286316,529.636841 573.173279,527.888000 570.981018,527.194214 
	C568.711548,526.476074 565.951843,526.620056 563.557007,527.114868 
	C556.570129,528.558472 552.299561,524.670166 548.339600,519.955322 
	C545.851135,516.992493 546.264587,504.017120 548.713745,501.025269 
	C552.605469,496.271210 557.002991,493.231598 563.652588,494.224762 
	C567.562683,494.808777 571.626953,494.360779 576.027893,494.440735 
z"/>
<path fill="#F0F1F2" opacity="1.000000" stroke="none" 
	d="
M461.640991,505.722931 
	C462.816742,499.692657 469.033630,494.376770 474.483124,494.349365 
	C478.645630,494.328461 482.859070,493.953094 486.953033,494.483215 
	C489.665344,494.834442 492.416412,496.172546 494.781799,497.656128 
	C500.139893,501.016754 501.093231,506.184845 499.750183,512.027466 
	C493.456726,513.817322 493.448090,513.393311 491.346619,507.435211 
	C488.539703,499.477020 481.369629,503.884430 476.131500,503.045837 
	C472.609161,502.481995 470.355774,504.826263 470.296234,508.333038 
	C470.132355,517.987366 470.242615,527.646301 470.246735,537.303406 
	C470.246796,537.469177 470.241608,537.647034 470.295563,537.799072 
	C473.116699,545.746704 479.861664,541.517883 484.899200,542.366882 
	C488.528229,542.978516 491.045013,541.064941 491.476532,537.257385 
	C491.733978,534.985840 491.523743,532.661255 491.523743,530.091187 
	C488.951904,529.810608 486.710968,529.566040 484.555054,529.330811 
	C482.900909,521.360474 483.165558,521.008362 490.573914,521.006836 
	C493.531647,521.006226 496.489380,521.006714 500.073822,521.006714 
	C500.073822,528.084534 500.307343,534.693848 499.980682,541.275330 
	C499.803101,544.852966 492.215637,550.854980 488.515076,550.917358 
	C484.852966,550.979126 481.105652,550.440857 477.543976,551.042969 
	C470.918488,552.163269 466.748932,548.734741 463.227539,544.092285 
	C462.154938,542.678284 461.727966,540.469055 461.704529,538.615173 
	C461.567627,527.794128 461.638550,516.970337 461.640991,505.722931 
z"/>
<path fill="#ECEEEF" opacity="1.000000" stroke="none" 
	d="
M227.281189,550.317993 
	C224.413422,547.292358 220.868454,544.863586 219.593231,541.558899 
	C217.090729,535.073792 219.440598,532.991394 226.221313,533.755615 
	C227.942078,536.724060 229.001907,541.017151 231.007980,541.517700 
	C235.687607,542.685242 241.040253,542.958374 245.713913,541.861816 
	C250.836823,540.659912 249.587662,535.274048 248.914062,531.638184 
	C248.580185,529.835999 245.610779,527.672913 243.509781,527.238037 
	C239.997589,526.510864 236.210068,526.828613 232.567474,527.098450 
	C229.092880,527.355896 226.690964,526.091919 224.300873,523.616577 
	C216.206177,515.232910 217.194061,502.106384 226.757553,495.486267 
	C227.880661,494.708862 229.521103,494.440643 230.941284,494.377625 
	C234.430603,494.222839 238.014130,494.807465 241.410217,494.224091 
	C248.424667,493.019287 253.036606,496.621368 256.406189,501.722443 
	C258.024628,504.172485 257.776855,507.855377 258.477936,511.522400 
	C254.954025,511.522400 252.408920,511.522400 249.873962,511.522400 
	C248.108749,502.951263 248.108749,502.951355 239.147202,502.953003 
	C237.815338,502.953247 236.483337,502.939575 235.151642,502.954010 
	C229.537079,503.014771 227.836609,504.764526 227.807648,510.495453 
	C227.775772,516.801819 229.190826,518.307983 235.237045,518.366333 
	C237.401123,518.387268 239.640106,518.731445 241.716171,518.303528 
	C248.554138,516.894165 252.595184,520.973328 256.444244,525.453735 
	C258.932587,528.350159 258.461639,541.476685 256.030151,544.427856 
	C252.253403,549.011841 247.994843,551.985229 241.532410,551.053833 
	C236.967407,550.395874 232.268875,550.664185 227.281189,550.317993 
z"/>
<path fill="#F1F3F3" opacity="1.000000" stroke="none" 
	d="
M649.276733,547.415833 
	C648.315613,553.657471 644.182556,549.796814 640.978577,551.029724 
	C640.978577,542.850281 640.978577,535.275574 640.978577,527.367065 
	C633.558960,527.367065 626.673462,527.367065 619.238647,527.367065 
	C619.238647,535.051025 619.238647,542.632263 619.238647,550.064880 
	C611.177429,552.023926 610.600891,551.601074 610.600220,544.240723 
	C610.598877,529.912659 610.597595,515.584595 610.601379,501.256561 
	C610.603333,493.648163 610.795715,493.498962 619.057983,495.027710 
	C619.057983,502.502014 619.057983,510.087494 619.057983,518.026367 
	C626.448975,518.026367 633.342285,518.026367 640.716248,518.026367 
	C640.716248,510.361786 640.716248,502.760864 640.716248,495.300537 
	C648.485535,493.119507 649.281189,493.688721 649.282166,500.991364 
	C649.284241,516.319092 649.280701,531.646790 649.276733,547.415833 
z"/>
<path fill="#E9EBEC" opacity="1.000000" stroke="none" 
	d="
M734.937744,502.966217 
	C728.806396,502.966217 723.166321,502.966217 717.113281,502.966217 
	C717.113281,508.018066 717.113281,512.745911 717.113281,518.253784 
	C723.754456,518.253784 730.618103,518.253784 737.742310,518.253784 
	C737.742310,521.447571 737.742310,523.875671 737.742310,526.868347 
	C730.898438,526.868347 724.156433,526.868347 716.855225,526.868347 
	C716.855225,534.972717 716.855225,542.535645 716.855225,549.912842 
	C708.956177,552.338196 708.037842,551.724365 708.036316,544.551208 
	C708.033142,529.394348 708.141052,514.236145 707.958679,499.081451 
	C707.914185,495.386108 708.958313,494.118439 712.747925,494.226288 
	C721.568420,494.477386 730.402771,494.409668 739.227600,494.253906 
	C742.438538,494.197266 744.103943,494.765991 744.071716,498.563446 
	C744.041626,502.121887 742.855652,503.413208 739.423096,502.990631 
	C738.110596,502.829071 736.761353,502.965546 734.937744,502.966217 
z"/>
<path fill="#F0F1F2" opacity="1.000000" stroke="none" 
	d="
M782.500122,545.663025 
	C782.499695,531.391052 782.499695,517.580933 782.499695,503.095215 
	C777.923584,503.095215 773.710815,503.095215 769.238098,503.095215 
	C769.238098,499.988586 769.238098,497.556976 769.238098,494.733826 
	C780.975830,494.733826 792.664185,494.733826 804.519165,494.733826 
	C804.519165,497.478241 804.519165,499.896118 804.519165,502.770874 
	C800.159058,502.770874 796.052979,502.770874 791.206116,502.770874 
	C791.206116,518.895203 791.206116,534.588257 791.206116,550.599243 
	C788.057007,550.599243 785.649231,550.599243 782.827271,550.599243 
	C782.712097,549.022034 782.606323,547.573486 782.500122,545.663025 
z"/>
<path fill="#E7EAEB" opacity="1.000000" stroke="none" 
	d="
M363.877319,501.306732 
	C364.495819,498.382507 362.010895,494.495544 367.333862,494.227051 
	C371.232941,494.030396 372.939117,494.860260 372.864014,499.308167 
	C372.600037,514.943848 372.768524,530.586792 372.751770,546.226990 
	C372.750397,547.529907 372.590668,548.832764 372.510162,550.050415 
	C364.762695,552.335144 363.878113,551.712280 363.877411,544.194458 
	C363.876068,530.051697 363.877045,515.908997 363.877319,501.306732 
z"/>
<path fill="#E7EAEB" opacity="1.000000" stroke="none" 
	d="
M683.009033,533.997986 
	C683.007568,538.815247 682.838989,543.141357 683.056641,547.447998 
	C683.236816,551.014709 681.111633,550.987976 678.597778,551.010315 
	C676.022400,551.033203 674.177979,550.908142 674.209106,547.395813 
	C674.354736,530.956665 674.175964,514.514709 674.319458,498.075531 
	C674.379272,491.223694 679.395874,495.425293 683.009033,494.159851 
	C683.009033,507.731506 683.009033,520.614990 683.009033,533.997986 
z"/>
<path fill="#E5E7E9" opacity="1.000000" stroke="none" 
	d="
M615.158081,575.042114 
	C618.216553,574.547974 621.348511,573.554077 623.730591,574.483093 
	C626.259705,575.469482 630.187256,578.823914 629.833130,580.198181 
	C628.444702,585.585815 635.365906,592.572205 627.424683,596.265259 
	C624.342041,597.698792 620.270996,597.192383 616.657532,597.131714 
	C615.989075,597.120544 614.819214,595.022888 614.795776,593.869629 
	C614.670898,587.712463 614.836487,581.549377 615.158081,575.042114 
M626.754517,590.366150 
	C625.572144,586.653809 622.652710,587.959717 620.253052,588.339111 
	C619.816650,588.408142 619.660645,590.250977 619.375122,591.274963 
	C621.436096,591.566772 623.492615,591.905945 625.562805,592.098633 
	C625.868774,592.127014 626.239258,591.462769 626.754517,590.366150 
M624.535400,579.278381 
	C622.792480,579.754761 621.049622,580.231140 619.306702,580.707520 
	C620.115417,581.639038 620.843140,583.260010 621.748840,583.366455 
	C624.017212,583.633240 626.277466,583.133240 624.535400,579.278381 
z"/>
<path fill="#DFE2E3" opacity="1.000000" stroke="none" 
	d="
M397.473206,588.994385 
	C398.576202,594.923523 401.508087,592.265198 404.081390,591.818054 
	C402.891113,589.389160 402.019958,587.611450 401.148834,585.833801 
	C403.632629,585.460022 406.116455,585.086182 408.556061,584.719055 
	C410.180511,593.795288 407.352417,597.854431 400.306824,597.562317 
	C395.613190,597.367676 392.948883,594.848450 392.715912,590.135071 
	C392.568604,587.154114 392.539795,584.150696 392.725250,581.174011 
	C392.987518,576.964722 395.213196,574.456116 399.578522,574.107605 
	C405.439819,573.639587 407.577179,575.097351 408.919739,581.159851 
	C407.355316,580.949402 405.847412,581.129089 404.760986,580.536316 
	C399.052734,577.421936 397.521210,578.199280 397.463837,584.517212 
	C397.451782,585.845215 397.465302,587.173462 397.473206,588.994385 
z"/>
<path fill="#DFE2E3" opacity="1.000000" stroke="none" 
	d="
M422.548889,578.037109 
	C425.899475,572.575073 430.893433,573.599426 435.260010,574.618164 
	C439.807587,575.679077 440.163452,579.888367 439.962280,583.919006 
	C439.896149,585.243225 439.856354,586.581665 439.967682,587.899841 
	C440.787323,597.608337 433.325867,598.858948 426.735504,596.970947 
	C424.772980,596.408691 422.522583,593.419556 422.205170,591.275757 
	C421.584808,587.085510 422.233215,582.707520 422.548889,578.037109 
M426.383453,581.999634 
	C426.377258,584.316101 426.432678,586.634705 426.350525,588.948486 
	C426.225189,592.479065 428.423859,592.903503 431.219910,592.927979 
	C434.140778,592.953552 435.527557,591.757690 435.372375,588.783386 
	C435.286285,587.133423 435.643433,585.413208 435.294495,583.836731 
	C434.911407,582.106201 433.881409,579.075134 433.246063,579.103882 
	C430.967896,579.206970 428.737427,580.364380 426.383453,581.999634 
z"/>
<path fill="#DFE2E3" opacity="1.000000" stroke="none" 
	d="
M585.213074,574.408447 
	C586.647217,575.278931 588.477844,576.239624 588.592590,577.373901 
	C588.975281,581.156982 588.454346,585.036255 588.897278,588.806091 
	C589.059692,590.188538 590.745117,592.121155 592.089294,592.480469 
	C594.705994,593.179993 595.939392,591.446045 595.874146,588.732178 
	C595.786316,585.078979 595.668762,581.407166 595.959473,577.774963 
	C596.058777,576.534546 597.351562,575.389709 598.098999,574.201172 
	C598.946777,575.297607 600.474792,576.364807 600.523376,577.495605 
	C600.722473,582.129578 600.653931,586.795837 600.330200,591.425476 
	C600.038757,595.593201 597.363770,597.431274 593.282898,597.595703 
	C589.075745,597.765259 584.945068,596.788940 584.473938,592.242310 
	C583.871521,586.428711 584.643738,580.472717 585.213074,574.408447 
z"/>
<path fill="#DFE2E3" opacity="1.000000" stroke="none" 
	d="
M531.899536,581.455322 
	C531.828125,583.740601 531.790039,585.573120 531.808533,587.405151 
	C531.862854,592.765320 533.758545,593.924744 538.502808,591.690735 
	C539.849854,591.056458 541.404968,590.863831 543.427734,590.316223 
	C542.787903,595.901672 539.765625,597.482300 535.519470,597.570251 
	C531.163818,597.660400 527.918396,595.941895 527.255127,591.364258 
	C526.829163,588.423950 527.124084,585.380310 527.081177,582.383179 
	C527.018555,578.004944 528.714417,574.914917 533.335754,574.174194 
	C538.841736,573.291809 541.370483,574.791687 543.771851,581.160278 
	C541.433594,580.542786 539.734375,580.268311 538.176270,579.642517 
	C535.720154,578.656067 533.424255,577.739380 531.899536,581.455322 
z"/>
<path fill="#E5E7E9" opacity="1.000000" stroke="none" 
	d="
M904.142395,533.667603 
	C901.920654,534.761963 900.079712,535.791565 896.931763,537.552063 
	C899.789673,531.517212 899.249634,527.245056 893.307007,524.270264 
	C898.901855,524.025330 903.606201,523.412109 904.017151,516.256287 
	C906.109436,521.446960 908.532349,525.316772 915.206116,523.841431 
	C910.482483,527.454773 908.457336,531.394104 911.971497,537.451538 
	C908.571960,535.694946 906.547546,534.648926 904.142395,533.667603 
z"/>
<path fill="#E5E7E9" opacity="1.000000" stroke="none" 
	d="
M116.385620,522.775391 
	C117.533737,520.544617 118.363983,518.589417 119.287903,516.413574 
	C123.454544,523.062866 123.454544,523.062866 130.260910,524.168945 
	C128.369659,526.129578 125.976776,527.546997 125.393913,529.503601 
	C124.768806,531.601929 125.846077,534.207458 126.204094,536.760437 
	C119.780373,533.860718 119.780373,533.860718 112.183617,536.970825 
	C115.255989,531.479980 114.017914,527.409668 107.683861,524.257141 
	C111.616936,523.691284 113.842346,523.371094 116.385620,522.775391 
z"/>
<path fill="#D5D9DB" opacity="1.000000" stroke="none" 
	d="
M561.654175,587.956116 
	C560.948486,592.596924 563.662415,592.262146 566.463806,592.493591 
	C567.971436,592.618103 569.372803,594.028198 570.822144,594.858276 
	C569.412354,595.718506 568.032410,597.265564 566.588013,597.328308 
	C556.673523,597.758911 556.668579,597.658936 556.669556,587.505798 
	C556.669922,584.025208 556.487061,580.528137 556.791199,577.074097 
	C556.882141,576.041931 558.340454,575.130249 559.172302,574.163330 
	C559.998474,575.116577 561.449280,576.015930 561.537109,577.032959 
	C561.835754,580.487854 561.652954,583.984375 561.654175,587.956116 
z"/>
<path fill="#D5D9DB" opacity="1.000000" stroke="none" 
	d="
M453.177856,585.986145 
	C453.179871,582.676147 452.958344,579.826782 453.299164,577.046448 
	C453.426636,576.006714 454.864594,575.127625 455.705017,574.175232 
	C456.466003,575.176208 457.833435,576.147339 457.884369,577.183228 
	C458.119446,581.965637 457.988068,586.766052 457.988068,592.074646 
	C460.957031,592.251038 463.677338,592.412659 466.714661,592.593079 
	C466.714661,594.186829 466.714661,595.573608 466.714661,597.055969 
	C465.919983,597.199402 465.282196,597.388550 464.636780,597.420044 
	C453.177887,597.979919 453.177673,597.975769 453.177856,585.986145 
z"/>
<path fill="#F4F5F5" opacity="1.000000" stroke="none" 
	d="
M484.771637,583.131409 
	C485.845428,583.239380 486.919189,583.347412 488.485260,583.761353 
	C489.558350,584.419983 490.139160,584.772766 490.720032,585.125549 
	C490.698669,585.686523 490.677307,586.247498 490.025391,586.945679 
	C484.750366,586.346313 482.603577,588.039001 483.010742,593.005676 
	C483.085205,593.913879 481.062775,594.994019 480.008301,595.994812 
	C480.008331,589.057068 480.008331,582.119385 480.008331,574.278259 
	C483.986237,574.278259 487.867462,574.169434 491.732147,574.373413 
	C492.473633,574.412537 493.150238,575.681396 493.856750,576.382935 
	C493.026611,577.133118 492.299042,578.319275 491.345154,578.543762 
	C489.293549,579.026550 487.125336,579.014221 484.430023,579.602173 
	C484.160675,581.043701 484.466156,582.087524 484.771637,583.131409 
z"/>
<path fill="#BFC5C9" opacity="1.000000" stroke="none" 
	d="
M544.322205,652.921875 
	C544.576538,655.456848 544.887390,657.624878 544.722778,659.756165 
	C544.352112,664.556946 540.838806,664.781128 537.105896,664.820496 
	C532.993713,664.863831 533.873108,661.964172 533.782471,659.595337 
	C533.738037,658.432922 533.563477,657.218323 533.820190,656.113892 
	C534.298462,654.056030 535.216614,650.286865 535.659180,650.328674 
	C538.537598,650.600403 541.337402,651.705688 544.322205,652.921875 
M541.386108,655.815125 
	C541.238892,653.374512 539.670288,652.021667 538.041077,653.901550 
	C536.931458,655.181946 537.380920,657.944885 537.469788,660.030579 
	C537.489380,660.491272 538.928772,660.891541 539.714417,661.319580 
	C540.275269,659.786560 540.836121,658.253540 541.386108,655.815125 
z"/>
<path fill="#C8CDD0" opacity="1.000000" stroke="none" 
	d="
M513.464478,703.324829 
	C511.655731,703.223267 510.039215,703.363892 508.804626,702.743958 
	C506.119019,701.395447 506.345001,699.630554 509.431671,697.370850 
	C507.140472,695.034790 504.916199,692.294556 508.482513,689.607666 
	C511.565887,687.284607 514.656982,687.897461 517.585938,692.505859 
	C516.440308,693.001831 515.113464,693.576294 513.758057,694.163086 
	C518.418091,698.528503 518.331726,700.199402 513.464478,703.324829 
M510.459045,699.228455 
	C511.496796,699.428284 512.534546,699.628113 513.572266,699.827881 
	C513.635620,699.307007 513.698975,698.786072 513.762268,698.265137 
	C512.621216,698.265137 511.480103,698.265137 510.459045,699.228455 
z"/>
<path fill="#BFC5C9" opacity="1.000000" stroke="none" 
	d="
M522.585083,664.717590 
	C518.946228,664.282776 514.248169,664.970459 517.572876,659.037292 
	C517.874023,658.499878 516.832092,657.343628 516.830383,656.473999 
	C516.827209,654.792358 516.511658,652.309387 517.430420,651.610046 
	C518.920837,650.475525 521.394653,649.938782 523.273987,650.246094 
	C524.591553,650.461487 525.610657,652.501953 526.763062,653.727295 
	C526.442261,654.083801 526.121460,654.440308 525.800659,654.796814 
	C523.981445,654.325134 522.162231,653.853394 519.936096,653.276184 
	C522.588928,656.108643 524.855103,658.290161 526.654907,660.805420 
	C526.841919,661.066711 524.260193,663.309265 522.585083,664.717590 
M522.165283,659.029724 
	C521.251404,659.128174 520.337524,659.226685 519.423645,659.325195 
	C519.592590,659.959961 519.761536,660.594727 519.930542,661.229492 
	C520.935425,660.687195 521.940247,660.144897 522.165283,659.029724 
z"/>
<path fill="#BFC5C9" opacity="1.000000" stroke="none" 
	d="
M495.158386,698.739136 
	C495.951996,695.071960 494.035858,691.246765 498.292114,688.637451 
	C498.292114,692.741943 498.921631,696.977417 498.102783,700.911438 
	C497.383850,704.365662 490.736969,704.817139 489.171173,701.526917 
	C487.187317,697.358276 487.585907,692.844238 488.902679,688.569702 
	C489.603271,688.537903 490.303894,688.506165 491.004517,688.474365 
	C491.135437,691.171936 491.254517,693.870117 491.400757,696.566772 
	C491.528290,698.918823 491.666870,701.296509 495.158386,698.739136 
z"/>
<path fill="#BFC5C9" opacity="1.000000" stroke="none" 
	d="
M473.720703,663.843872 
	C470.505951,663.657593 465.741058,664.067810 465.131775,662.668457 
	C463.824677,659.666626 464.146545,655.615051 464.905670,652.241760 
	C465.165497,651.087402 468.791809,649.955322 470.751434,650.144592 
	C472.405884,650.304443 475.072021,652.288330 475.186981,653.643250 
	C475.464417,656.913330 474.511169,660.287781 473.720703,663.843872 
M467.046387,655.734741 
	C467.445374,658.230042 465.482269,662.442505 470.834167,661.322754 
	C471.547546,661.173462 472.203705,658.956360 472.210449,657.693237 
	C472.218292,656.225159 471.481110,654.753052 471.067291,653.282715 
	C469.740875,653.814026 468.414429,654.345276 467.046387,655.734741 
z"/>
<path fill="#D5D9DB" opacity="1.000000" stroke="none" 
	d="
M591.691406,655.927979 
	C593.109558,658.410400 593.109558,658.410400 587.730164,660.145569 
	C590.874878,661.201050 593.048950,661.930725 595.223022,662.660400 
	C595.141907,663.198486 595.060730,663.736633 594.979614,664.274719 
	C592.157288,664.416260 589.334961,664.557800 586.081238,664.721008 
	C586.081238,659.769653 586.081238,655.223938 586.081238,650.352905 
	C588.990479,650.352905 591.845093,650.352905 594.699707,650.352905 
	C594.861328,650.835266 595.022949,651.317566 595.184570,651.799927 
	C593.164062,652.550415 591.143616,653.300903 588.195557,654.395996 
	C589.655273,655.073425 590.489136,655.460388 591.691406,655.927979 
z"/>
<path fill="#C8CDD0" opacity="1.000000" stroke="none" 
	d="
M528.707214,689.233765 
	C529.636292,689.225647 530.749573,689.252686 530.932251,689.678772 
	C532.772339,693.969360 534.459900,698.325500 536.296387,702.928955 
	C535.387817,702.943970 524.059692,703.130981 523.005432,703.148376 
	C524.911865,698.361755 526.685730,693.907898 528.707214,689.233765 
z"/>
<path fill="#BFC5C9" opacity="1.000000" stroke="none" 
	d="
M448.262665,663.798462 
	C447.502686,660.214539 446.484100,656.795715 446.879456,653.549072 
	C447.049164,652.155518 450.068451,650.371094 451.955658,650.149597 
	C453.570068,649.960083 455.416718,651.748962 456.963074,653.405212 
	C453.467957,654.032043 449.092072,651.705627 449.760834,658.246277 
	C450.391937,664.418701 454.284668,659.397217 456.272797,660.480530 
	C455.663971,664.955505 454.242126,665.589539 448.262665,663.798462 
z"/>
<path fill="#D5D9DB" opacity="1.000000" stroke="none" 
	d="
M551.196045,662.002930 
	C552.890991,657.765320 554.486206,653.888977 556.081482,650.012634 
	C556.633728,649.983643 557.186035,649.954651 557.738342,649.925598 
	C559.600342,654.548340 561.462341,659.171143 563.324341,663.793884 
	C562.997009,664.033386 562.669617,664.272827 562.342285,664.512329 
	C561.577332,664.146973 560.586853,663.972656 560.086975,663.382751 
	C558.043945,660.971863 556.051636,660.943176 553.943848,663.198669 
	C552.418884,664.830505 551.268127,665.296570 551.196045,662.002930 
z"/>
<path fill="#D5D9DB" opacity="1.000000" stroke="none" 
	d="
M435.090454,656.852356 
	C436.739288,658.355164 438.013092,659.797058 439.286896,661.238892 
	C437.049347,662.208801 434.873810,663.653748 432.549255,663.957214 
	C431.304138,664.119690 429.802490,662.317261 428.416595,661.401550 
	C428.684113,661.042358 428.951630,660.683167 429.219116,660.324036 
	C431.379333,660.676025 433.539581,661.028076 435.699799,661.380127 
	C435.817993,660.891174 435.936218,660.402222 436.054413,659.913269 
	C433.499359,657.979797 427.865784,658.554321 429.504303,653.315063 
	C429.975311,651.809021 432.884003,650.349915 434.763336,650.227722 
	C436.246277,650.131348 437.864685,652.118591 439.422943,653.180481 
	C439.112457,653.671692 438.801941,654.162903 438.491425,654.654114 
	C436.688385,654.124146 434.885376,653.594116 433.082336,653.064087 
	C432.870117,653.401489 432.657928,653.738892 432.445709,654.076294 
	C433.202301,654.981323 433.958862,655.886353 435.090454,656.852356 
z"/>
<path fill="#C8CDD0" opacity="1.000000" stroke="none" 
	d="
M503.254333,649.978638 
	C505.443756,649.978088 507.199280,649.978088 508.415619,649.978088 
	C507.004852,655.276855 505.757782,659.960815 504.120544,666.110107 
	C502.731689,660.297058 501.677307,655.884094 500.401215,650.543213 
	C500.357574,650.553406 501.589020,650.266296 503.254333,649.978638 
z"/>
<path fill="#BFC5C9" opacity="1.000000" stroke="none" 
	d="
M488.644592,661.431274 
	C487.938812,662.745300 487.236481,663.644775 486.534149,664.544250 
	C486.074829,663.602600 485.396393,662.705261 485.195709,661.711426 
	C484.482880,658.180725 483.932892,654.617065 483.244263,650.619019 
	C485.185150,650.619019 488.369324,650.619019 490.798523,650.619019 
	C490.082123,654.082764 489.365082,657.549744 488.644592,661.431274 
z"/>
<path fill="#C8CDD0" opacity="1.000000" stroke="none" 
	d="
M569.600708,653.591125 
	C570.119324,652.077271 570.633972,650.990356 571.148682,649.903381 
	C571.647400,650.011902 572.146118,650.120422 572.644836,650.228943 
	C572.840393,653.710510 573.036011,657.192078 573.226379,660.580200 
	C573.617310,660.856140 573.857849,661.079224 574.140198,661.216187 
	C575.569885,661.909912 577.010437,662.581177 578.447144,663.260315 
	C577.538452,663.750732 576.507874,664.793884 575.744507,664.625610 
	C573.648010,664.163269 570.445374,663.677979 569.902466,662.315979 
	C568.937012,659.894287 569.609497,656.819580 569.600708,653.591125 
z"/>
<path fill="#AAB2B7" opacity="1.000000" stroke="none" 
	d="
M461.446411,408.632721 
	C460.464752,405.920593 459.480042,403.385101 459.449188,400.838074 
	C459.438812,399.981476 461.877777,398.380249 463.153076,398.423462 
	C464.437073,398.466888 466.626831,400.045837 466.721497,401.103882 
	C466.925171,403.381378 466.287842,405.853271 465.442108,408.030975 
	C465.196655,408.662994 463.076721,408.567078 461.446411,408.632721 
z"/>
<path fill="#AAB2B7" opacity="1.000000" stroke="none" 
	d="
M450.478210,409.257385 
	C445.077515,405.709869 451.281342,404.873596 451.456024,402.167877 
	C450.932587,401.949005 450.028809,401.571136 449.125031,401.193237 
	C449.035583,400.711456 448.946106,400.229675 448.856659,399.747894 
	C450.701019,399.475494 452.545410,399.203094 454.389771,398.930695 
	C454.389771,401.123962 454.389771,403.317200 454.389771,405.510468 
	C453.987610,405.517975 453.585449,405.525482 453.183289,405.532990 
	C453.962463,406.275696 454.741669,407.018372 456.340759,408.542542 
	C453.874207,408.878601 452.354095,409.085693 450.478210,409.257385 
z"/>
<path fill="#AAB2B7" opacity="1.000000" stroke="none" 
	d="
M559.865601,405.074585 
	C560.752930,404.239746 561.389221,403.712799 562.434143,402.847595 
	C561.403931,402.144135 560.515076,401.537201 559.626221,400.930237 
	C559.613220,400.447021 559.600159,399.963806 559.587158,399.480591 
	C561.529846,399.345459 563.472595,399.210297 565.415344,399.075134 
	C565.415344,401.154022 565.415344,403.232910 565.415344,405.311829 
	C564.955383,405.376984 564.495422,405.442139 564.035461,405.507294 
	C564.835938,406.204468 565.636353,406.901611 567.407593,408.444244 
	C564.569458,408.715240 562.678162,409.246521 560.977356,408.884155 
	C560.304932,408.740875 560.056274,406.608948 559.865601,405.074585 
M563.590271,401.646790 
	C563.401062,401.627411 563.211792,401.608063 563.022583,401.588684 
	C563.107422,401.693298 563.192261,401.797913 563.590271,401.646790 
z"/>
<path fill="#C8CDD0" opacity="1.000000" stroke="none" 
	d="
M569.384521,406.985901 
	C570.319336,403.998718 571.582703,401.129944 572.846069,398.261139 
	C573.556396,398.418243 574.266724,398.575378 574.977051,398.732513 
	C575.211975,401.865967 575.446838,404.999451 575.732117,408.804688 
	C573.008911,408.035339 571.361023,407.569794 569.384521,406.985901 
z"/>
<path fill="#DFE2E3" opacity="1.000000" stroke="none" 
	d="
M476.795471,380.151062 
	C476.770325,381.736725 476.745209,383.322357 476.720093,384.908020 
	C475.396820,384.724274 473.028687,384.770081 472.929230,384.317444 
	C472.472748,382.240082 472.264069,379.927063 472.769348,377.898651 
	C473.009766,376.933746 475.043945,376.415710 476.553772,375.886383 
	C476.863434,376.345459 476.884918,376.613464 476.906372,376.881439 
	C476.906372,376.881439 476.914948,376.962189 476.551605,377.006958 
	C474.871216,378.382477 473.857330,379.653870 476.795471,380.151062 
z"/>
<path fill="#869299" opacity="1.000000" stroke="none" 
	d="
M477.261108,376.895752 
	C476.884918,376.613464 476.863434,376.345459 476.898682,375.677795 
	C480.728271,372.536346 484.501068,369.794556 488.754730,367.307800 
	C489.600403,367.826904 489.965210,368.090942 490.330017,368.354980 
	C486.091980,371.206696 481.853912,374.058350 477.261108,376.895752 
z"/>
<path fill="#AAB2B7" opacity="1.000000" stroke="none" 
	d="
M479.996338,596.355469 
	C481.062775,594.994019 483.085205,593.913879 483.010742,593.005676 
	C482.603577,588.039001 484.750366,586.346313 489.833984,587.158569 
	C488.697235,587.890686 487.121307,588.547058 485.201782,589.346497 
	C481.951904,590.367676 489.411316,599.490417 479.996338,596.355469 
z"/>
<path fill="#869299" opacity="1.000000" stroke="none" 
	d="
M518.320068,422.810547 
	C519.182922,419.353455 520.572021,415.966736 521.961121,412.580048 
	C522.461609,412.764709 522.962097,412.949402 523.462585,413.134064 
	C522.466553,416.369232 521.470520,419.604370 520.179871,422.970123 
	C519.538879,423.027435 519.192627,422.954193 518.320068,422.810547 
z"/>
<path fill="#AAB2B7" opacity="1.000000" stroke="none" 
	d="
M490.637573,368.220123 
	C489.965210,368.090942 489.600403,367.826904 489.098267,367.253174 
	C491.156860,365.392761 493.352783,363.842072 495.864380,362.153259 
	C496.458344,362.308807 496.736633,362.602478 497.052246,363.204102 
	C495.041473,365.036469 492.993317,366.560883 490.637573,368.220123 
z"/>
<path fill="#AAB2B7" opacity="1.000000" stroke="none" 
	d="
M506.648529,357.461884 
	C506.076477,356.753693 505.504425,356.045532 504.837158,355.008484 
	C505.567841,354.528137 506.393707,354.376617 507.633820,354.142456 
	C508.307587,354.476990 508.567169,354.894165 508.798615,355.820801 
	C508.063141,356.707428 507.355835,357.084656 506.648529,357.461884 
z"/>
<path fill="#AAB2B7" opacity="1.000000" stroke="none" 
	d="
M502.057068,351.569336 
	C500.935577,351.849335 499.712067,351.828613 498.042908,351.693298 
	C499.049866,351.475342 500.502472,351.371979 502.057068,351.569336 
z"/>
<path fill="#AAB2B7" opacity="1.000000" stroke="none" 
	d="
M484.780762,582.706665 
	C484.466156,582.087524 484.160675,581.043701 484.132019,579.891174 
	C484.535858,580.615662 484.662903,581.448792 484.780762,582.706665 
z"/>
<path fill="#869299" opacity="1.000000" stroke="none" 
	d="
M518.897461,436.180237 
	C519.199463,436.887512 519.269897,437.775482 519.104858,438.831726 
	C518.801575,438.120331 518.733765,437.240601 518.897461,436.180237 
z"/>
<path fill="#869299" opacity="1.000000" stroke="none" 
	d="
M476.762512,379.744751 
	C473.857330,379.653870 474.871216,378.382477 476.524109,376.977081 
	C476.816467,377.714447 476.773041,378.526459 476.762512,379.744751 
z"/>
<path fill="#AAB2B7" opacity="1.000000" stroke="none" 
	d="
M494.158081,354.656097 
	C494.473450,355.160950 494.581451,355.813934 494.598022,356.959351 
	C494.321350,356.569305 494.136078,355.686737 494.158081,354.656097 
z"/>
<path fill="#AAB2B7" opacity="1.000000" stroke="none" 
	d="
M490.825745,584.792358 
	C490.139160,584.772766 489.558350,584.419983 488.887756,583.820435 
	C489.509125,583.868896 490.220337,584.164001 490.825745,584.792358 
z"/>
<path fill="#AAB2B7" opacity="1.000000" stroke="none" 
	d="
M500.517670,371.078369 
	C500.982086,371.417633 501.304993,372.048096 501.432404,372.822113 
	C500.950012,372.433594 500.663116,371.901581 500.517670,371.078369 
z"/>
<path fill="#2F4754" opacity="1.000000" stroke="none" 
	d="
M506.594788,357.794189 
	C507.355835,357.084656 508.063141,356.707428 508.889008,356.050385 
	C509.662659,355.688751 510.328918,355.487183 510.970886,355.546783 
	C513.266479,355.759918 516.541504,354.584869 516.738525,358.271698 
	C516.788147,359.200134 514.172485,360.834290 512.581421,361.157013 
	C510.100555,361.660187 506.581757,362.984436 506.594788,357.794189 
z"/>
<path fill="#2F4754" opacity="1.000000" stroke="none" 
	d="
M626.667236,590.742554 
	C626.239258,591.462769 625.868774,592.127014 625.562805,592.098633 
	C623.492615,591.905945 621.436096,591.566772 619.375122,591.274963 
	C619.660645,590.250977 619.816650,588.408142 620.253052,588.339111 
	C622.652710,587.959717 625.572144,586.653809 626.667236,590.742554 
z"/>
<path fill="#2F4754" opacity="1.000000" stroke="none" 
	d="
M624.812866,579.542297 
	C626.277466,583.133240 624.017212,583.633240 621.748840,583.366455 
	C620.843140,583.260010 620.115417,581.639038 619.306702,580.707520 
	C621.049622,580.231140 622.792480,579.754761 624.812866,579.542297 
z"/>
<path fill="#2F4754" opacity="1.000000" stroke="none" 
	d="
M426.436188,581.561401 
	C428.737427,580.364380 430.967896,579.206970 433.246063,579.103882 
	C433.881409,579.075134 434.911407,582.106201 435.294495,583.836731 
	C435.643433,585.413208 435.286285,587.133423 435.372375,588.783386 
	C435.527557,591.757690 434.140778,592.953552 431.219910,592.927979 
	C428.423859,592.903503 426.225189,592.479065 426.350525,588.948486 
	C426.432678,586.634705 426.377258,584.316101 426.436188,581.561401 
z"/>
<path fill="#2F4754" opacity="1.000000" stroke="none" 
	d="
M541.391541,656.267822 
	C540.836121,658.253540 540.275269,659.786560 539.714417,661.319580 
	C538.928772,660.891541 537.489380,660.491272 537.469788,660.030579 
	C537.380920,657.944885 536.931458,655.181946 538.041077,653.901550 
	C539.670288,652.021667 541.238892,653.374512 541.391541,656.267822 
z"/>
<path fill="#1C3645" opacity="1.000000" stroke="none" 
	d="
M510.399048,698.746826 
	C511.480103,698.265137 512.621216,698.265137 513.762268,698.265137 
	C513.698975,698.786072 513.635620,699.307007 513.572266,699.827881 
	C512.534546,699.628113 511.496796,699.428284 510.399048,698.746826 
z"/>
<path fill="#1C3645" opacity="1.000000" stroke="none" 
	d="
M522.555176,659.316162 
	C521.940247,660.144897 520.935425,660.687195 519.930542,661.229492 
	C519.761536,660.594727 519.592590,659.959961 519.423645,659.325195 
	C520.337524,659.226685 521.251404,659.128174 522.555176,659.316162 
z"/>
<path fill="#2F4754" opacity="1.000000" stroke="none" 
	d="
M467.067200,655.305664 
	C468.414429,654.345276 469.740875,653.814026 471.067261,653.282715 
	C471.481110,654.753052 472.218292,656.225159 472.210449,657.693237 
	C472.203705,658.956360 471.547546,661.173462 470.834167,661.322754 
	C465.482269,662.442505 467.445374,658.230042 467.067200,655.305664 
z"/>
<path fill="#1C3645" opacity="1.000000" stroke="none" 
	d="
M563.433655,401.774658 
	C563.192261,401.797913 563.107422,401.693298 563.022583,401.588684 
	C563.211792,401.608063 563.401062,401.627411 563.433655,401.774658 
z"/>
    </svg>
  )
}
